/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Fragment } from 'react';
import { InlineContext } from '../../../context/inline';
export var Text = function Text(props) {
  var forgeDoc = props.forgeDoc,
    render = props.render;
  return jsx(InlineContext.Provider, {
    value: {
      inline: true
    }
  }, jsx("p", null, forgeDoc.children.map(function (child) {
    // React expects a key on each child when rendering an array
    return jsx(Fragment, {
      key: child.key
    }, render(child));
  })));
};